/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { StyleSheet } from 'react-native';
import LoadingIndicator from '../uiold/LoadingIndicator';
import { Modal } from '../uiold';
import { ModalProps } from '../uiold/Modal';

type Props = Pick<ModalProps, 'onClose' | 'style' | 'title' | 'children'> & {
  isLoading?: boolean;
  vendorCounter?: number;
  noBodyDefault?: boolean;
};

function AdminModal(props: Props) {
  const {
    onClose,
    isLoading = false,
    children,
    noBodyDefault = false,
    title,
    style,
    ...otherProps
  } = props;

  return (
    <Modal
      isVisible
      onClose={onClose}
      style={[styles.modal, style]}
      {...otherProps}
    >
      <Modal.Header title={title} />
      {!noBodyDefault ? (
        <Modal.Body style={styles.modalBody}>
          {isLoading ? <LoadingIndicator /> : children}
        </Modal.Body>
      ) : (
        children
      )}
    </Modal>
  );
}

const styles = StyleSheet.create({
  modal: {
    width: 400,
  },
  modalBody: {
    paddingLeft: 20,
    paddingRight: 20,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column' as any,
  },
});

AdminModal.Body = Modal.Body;
AdminModal.Footer = Modal.Footer;

export default AdminModal;
